import { render, staticRenderFns } from "./DJDeck.vue?vue&type=template&id=62f11bc7&"
import script from "./DJDeck.vue?vue&type=script&lang=js&"
export * from "./DJDeck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports